import { memo } from 'react'

import { List } from 'shared/components/list'

import styles from './EmptyListItem.module.scss'

export const EmptyListItem = memo(() => {
  return (
    <List.Label className={styles.item}>
      <span className={styles.caption}>Empty list</span>
    </List.Label>
  )
})

EmptyListItem.displayName = 'EmptyListItem'
